import { createSlice } from '@reduxjs/toolkit';
import { SystemConfigDetailStateType } from 'src/types/systemConfigDetail';

const initialState: SystemConfigDetailStateType = {
    data: null,
    structureData: null,
    loading: false,
    error: false,
};
export const systemConfigDetailSlice = createSlice({
    name: 'systemConfigDetail',
    initialState,
    reducers: {
        getSystemConfigDetailFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getSystemConfigDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getSystemConfigDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateSystemConfigDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateSystemConfigDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateSystemConfigDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        getSystemConfigStructureFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getSystemConfigStructureFetchSuccess: (state, action) => {
            state.structureData = action.payload.data;
            state.loading = false;
        },
        getSystemConfigStructureFetchFailure: (state, action) => {
            state.structureData = null;
            state.loading = false;
            state.error = true;
        },
        createSystemConfigStructureFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createSystemConfigStructureFetchSuccess: (state, action) => {
            // state.data = action.payload.data;
            state.loading = false;
        },
        createSystemConfigStructureFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateSystemConfigStructureFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateSystemConfigStructureFetchSuccess: (state, action) => {
            // state.data = action.payload.data;
            state.loading = false;
        },
        updateSystemConfigStructureFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearSystemConfigDetail: () => initialState,
    },
});

export const {
    getSystemConfigDetailFetch,
    getSystemConfigDetailFetchSuccess,
    getSystemConfigDetailFetchFailure,
    updateSystemConfigDetailFetch,
    updateSystemConfigDetailFetchSuccess,
    updateSystemConfigDetailFetchFailure,
    getSystemConfigStructureFetch,
    getSystemConfigStructureFetchSuccess,
    getSystemConfigStructureFetchFailure,
    createSystemConfigStructureFetch,
    createSystemConfigStructureFetchSuccess,
    createSystemConfigStructureFetchFailure,
    updateSystemConfigStructureFetch,
    updateSystemConfigStructureFetchSuccess,
    updateSystemConfigStructureFetchFailure,
    clearSystemConfigDetail,
} = systemConfigDetailSlice.actions;

export default systemConfigDetailSlice.reducer;
